// import { get, post, del, put } from '@/utils/request'
import { get, put, Delete, post } from '../axios'

// 查询字典列表---begin---

// 分页查询字典
export const getDictionary = (data) => post('/web/dict/page', data)

// 检查字典编码是否存在
export const isHaveDictionary = (params) => get('/web/dict/checkCode', params)

// 新增字典
export const addDictionary = (data) => post('/web/dict/add', data)

// 批量(单个)删除字典
export const deleteDictionary = (ids) => Delete('/web/dict/delete/' + ids)

// 根据ID获取字典
export const getDictionaryDetails = (id) => get('/web/dict/get/' + id)

// 更新字典
export const updateDictionary = (data) => put('/web/dict/update', data)

// 查询字典列表---end---

// 查询字典项列表---begin---

// 新增字典项
export const addItemDictionary = (data) => post('/web/dictItem/add', data)

// 批量(单个)删除字典项
export const deleteItemDictionary = (data) => Delete('/web/dictItem/delete/' + data)

// 分页查询字典项
export const getItemDictionary = (data) => post('/web/dictItem/page', data)

// 更新字典项
export const updateItemDictionary = (data) => put('/web/dictItem/update', data)

// 检查字典项编码是否存在
export const isHaveItemDictionary = (params) => get('/web/dictItem/checkCode', params)

// 根据ID获取字典项
export const getIdItemDictionary = (id) => get('/web/dictItem/get/' + id)

// 根据字典dictCode获取字典项列表
export const getListItemDictionary = (dictId) => get('/web/dictItem/list/' + dictId)

// 查询字典项列表---end---
